export default __webpack_public_path__ + "static/media/arrow.a6612c7c.svg";